import { SelectOption } from '@tassat/common-definitions';
import { createContext } from 'react';

export interface IConstantsContext {
    FIS_DDA_TIMEOUT: string;
    ENV: string;
    APP_NAME: string;
    inactivityLogoutOffset: string;
    inactivityWarningDuration: string;
}

export const retrieveConfiguredConstants = async () => {
    try {
        const response = await fetch('/const');
        const constants = response.json();

        return constants;
    } catch (error) {
        console.error(error);

        return {};
    }
};

const ConstantsContext = createContext<IConstantsContext | null>(null);
export { ConstantsContext };

/*         SYSTEM        */
export const CORE_SUCCESS_CODE = 48; // 0
export const CORE_REJECT_CODE = 49; // 1
export const JS_TIMER_MAX = 2147483647;
export const BASE_CLIENT_URL = '/accounts';
export const MAX_SEARCH_RESULTS = 50;
export const MAX_COUNT_PCGS = 3;
export const PCG_ALL: { id: string; number: string } = {
    id: '999999999999999999',
    number: 'ALL'
};
export const ACG_ALL: { id: string; number: string } = {
    id: '999999999999999999',
    number: 'ALL'
};
export const emptySelectOption: SelectOption = {
    label: 'Select an option...',
    value: ''
};

/*         TIMERS/TIMEOUTS        */
export const FALLBACK_API_TIMEOUT = 4000;
export const FALLBACK_FIS_TIMEOUT = 4000;
export const SERVER_TIMEOUT = 3000;
export const EXPORT_SERVER_TIMEOUT = 4000;
// Timer length for user internet disconnection, initially set to 30 seconds
export const NO_INTERNET_TIMER_LENGTH = 30000;
// Timer length for inactivity
export const INACTIVITY_WARNING_DURATION = 1000 * 60 * 14; // 14 minutes
export const LOGOUT_OFFSET_DURATION = 1000 * 60 * 1; // 60 seconds

/*         COLORS        */
export const DEFAULT_ICON_COLOR = '#575756';
export const LOCK_ICON_COLOR = '#F5824A';
export const HANDSHAKE_ICON_COLOR = '#375073';
export const NETWORK_ICON_COLOR = '#003C70';

/*         AG GRID        */
export const AG_GRID_SMALL_HEADER_HEIGHT = 45;
export const DEFAULT_ITEMS_PER_PAGE = 50;

/*        Reg Ex         */
export const NON_ALPHANUMERIC_REGEX = RegExp('[^a-zA-Z0-9]', 'g');

/*        RECORDS PER EXPORT         */
export const TRANSACTIONS_PER_EXPORT = 400000;
export const CLIENTMESSAGES_PER_EXPORT = 100000;
export const API_TRANSACTIONS_PER_EXPORT = 400000;

/*        CURRENCY         */
export const currencyUSD = {
    AlphabeticCode: 'USD',
    NumericCode: 840,
    CurrencyDescription: 'US Dollar',
    Symbol: '$',
    DecimalPoint: 2,
    IsEnabled: true,
    BitOffset: 1
};

/*        CURRENCY as ASSET         */
export const assetUSD = {
    AssetId: '20240323333344444',
    CountryCode: 'USA',
    Curcode: 'USD',
    Cusip: 'Some_Cusip',
    Description: 'US Dollar',
    Symbol: '$',
    Ticker: 'DXR',
    Type: 'Ccy',
    DecimalPoint: 2,
    IsEnabled: true,
    BitOffset: 1
};

export const currencyViewAll = {
    AlphabeticCode: 'ALL',
    NumericCode: 9999
};

export const assetViewAll = {
    AlphabeticCode: 'ALL',
    AssetId: '9999'
};

/*       AUTH         */

export enum LoginMethodType {
    HOSTED_KEYCLOAK = 'HostedKeycloak'
}